//@ts-check
/**
MIT License

Copyright (c) 2017 Niladri

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
export function multiply(number1, number2) {
  number1 = number1.toString();
  number2 = number2.toString();

  /*Filter numbers*/
  let negative = 0;
  if (number1[0] == '-') {
    negative++;
    number1 = number1.substr(1);
  }
  if (number2[0] == '-') {
    negative++;
    number2 = number2.substr(1);
  }
  number1 = trailZero(number1);
  number2 = trailZero(number2);
  let decimalLength1 = 0;
  let decimalLength2 = 0;

  if (number1.indexOf('.') != -1) {
    decimalLength1 = number1.length - number1.indexOf('.') - 1;
  }

  if (number2.indexOf('.') != -1) {
    decimalLength2 = number2.length - number2.indexOf('.') - 1;
  }
  const decimalLength = decimalLength1 + decimalLength2;
  number1 = trailZero(number1.replace('.', ''));
  number2 = trailZero(number2.replace('.', ''));

  if (number1.length < number2.length) {
    const temp = number1;
    number1 = number2;
    number2 = temp;
  }

  if (number2 == '0') {
    return '0';
  }

  /*
   * Core multiplication
   */
  const length = number2.length;
  let carry = 0;
  const positionVector = [];
  let currentPosition = length - 1;

  let result = '';
  for (let i = 0; i < length; i++) {
    positionVector[i] = number1.length - 1;
  }
  for (let i = 0; i < 2 * number1.length; i++) {
    let sum = 0;
    for (let j = number2.length - 1; j >= currentPosition && j >= 0; j--) {
      if (positionVector[j] > -1 && positionVector[j] < number1.length) {
        sum += parseInt(number1[positionVector[j]--]) * parseInt(number2[j]);
      }
    }
    sum += carry;
    carry = Math.floor(sum / 10);
    result = (sum % 10) + result;
    currentPosition--;
  }
  /*
   * Formatting result
   */
  result = trailZero(adjustDecimal(result, decimalLength));
  if (negative == 1) {
    result = '-' + result;
  }
  return result;
}

/*
 * Add decimal point
 */
function adjustDecimal(number, decimal) {
  if (decimal == 0) return number;
  else {
    number =
      decimal >= number.length ? new Array(decimal - number.length + 1).join('0') + number : number;
    return (
      number.substr(0, number.length - decimal) +
      '.' +
      number.substr(number.length - decimal, decimal)
    );
  }
}

/*
 * Removes zero from front and back*/
function trailZero(number) {
  while (number[0] == '0') {
    number = number.substr(1);
  }
  if (number.indexOf('.') != -1) {
    while (number[number.length - 1] == '0') {
      number = number.substr(0, number.length - 1);
    }
  }
  if (number == '' || number == '.') {
    number = '0';
  } else if (number[number.length - 1] == '.') {
    number = number.substr(0, number.length - 1);
  }
  if (number[0] == '.') {
    number = '0' + number;
  }
  return number;
}
